module.exports = __webpack_public_path__ + "static/media/reaction-bg.f6067b19.svg";